import Button from 'components/Button'
import { ArrowDownIcon } from 'components/Icon/icons/arrow-down'
import { View } from 'components/View.js'
import React from 'react'

export default function ArrowButton ({
  type,
  onClick
}) {
  return (
    <Button onClick={onClick}>
      {/* <Surface bdr='50%'> */}
      <View
        // bdr='50%'
        // bgc='white'
        // bd
        z={1}
        style={{
          width: '30px',
          height: '30px',
          padding: '5px'
        }}
      >
        <ArrowDownIcon
          style={{
            transform: type === 'right'
              ? 'rotate(-90deg)'
              : 'rotate(90deg)',
            width: '100%',
            height: '100%'
          }}
        />
      </View>
      {/* </Surface> */}
    </Button>
  )
}
